import React, { useState } from "react";
import {
  CTabs,
  CTabList,
  CTab,
  CTabContent,
  CTabPanel,
  CButton,
  CTable,
  CTableHead,
  CTableBody,
  CTableRow,
  CTableHeaderCell,
  CTableDataCell,
  CFormCheck,
  CFormSelect,
} from "@coreui/react";
import "./AddWindow.scss";

function AddWindow({ isOpen, onClose }) {
  const [activeTab, setActiveTab] = useState(1);
  const [specialists, setSpecialists] = useState([{ id: 1, executor: '', position: '', certificate: '', workType: '' }]);
  const [measurementTools, setMeasurementTools] = useState([{ id: 1, workName: '', content: '', tool: '' }]);
  const [showVerification, setShowVerification] = useState(false);

  const handleAddSpecialist = () => {
    const newId = specialists.length ? specialists[specialists.length - 1].id + 1 : 1;
    setSpecialists([...specialists, { id: newId, executor: '', position: '', certificate: '', workType: '' }]);
  };

  const handleRemoveSpecialist = (id) => {
    setSpecialists(specialists.filter(s => s.id !== id));
  };

  const handleAddMeasurementTool = () => {
    const newId = measurementTools.length ? measurementTools[measurementTools.length - 1].id + 1 : 1;
    setMeasurementTools([...measurementTools, { id: newId, workName: '', content: '', tool: '' }]);
  };

  const handleRemoveMeasurementTool = (id) => {
    setMeasurementTools(measurementTools.filter(t => t.id !== id));
  };

  if (!isOpen) return null;

  return (
    <div className="addwindow-overlay" onClick={onClose}>
      <div className="addwindow-content" onClick={(e) => e.stopPropagation()}>
        <CTabs
          activeItemKey={activeTab}
          onActiveItemChange={(key, event) => {
            event.stopPropagation();
            setActiveTab(key);
          }}
        >
          <CTabList className="custom-tab-list" variant="tabs" layout="fill">
            {[
              "Сведения об объекте",
              "Основание выполнения работ",
              "Сведения о специалистах",
              "Средства измерения и контроля",
              "Сведения об организации, проводившей обследование",
              "Программа работ",
              "Климатические параметры",
              "Состав пояснительной записки",
            ].map((title, index) => (
              <CTab key={index + 1} itemKey={index + 1} className="custom-tab">
                {title}
              </CTab>
            ))}
          </CTabList>

          <CTabContent className="ctab-content">
            {/* Сведения об объекте */}
            <CTabPanel itemKey={1}>
              <div className="fields-container">
                <div className="fields-row">
                  <div className="field-group">
                    <label htmlFor="objectId">ID объекта:</label>
                    <input type="text" id="objectId" />
                  </div>
                  <div className="field-group">
                    <label htmlFor="objectIndex">Индекс ID объекта:</label>
                    <input type="text" id="objectIndex" />
                  </div>
                </div>
                <CTable bordered hover>
                  <CTableHead>
                    <CTableRow>
                      <CTableHeaderCell>Описание</CTableHeaderCell>
                      <CTableHeaderCell>Значение</CTableHeaderCell>
                    </CTableRow>
                  </CTableHead>
                  <CTableBody>
                    {[
                      "Объект",
                      "Регион",
                      "Адрес объекта",
                      "Собственник объекта",
                      "Форма собственности объекта",
                      "Статус объекта",
                      "Год возведения",
                      "Год ввода в эксплуатацию",
                      "Тип проекта",
                      "Разработчик проекта",
                      "Строительная организация",
                      "Последний кап. ремонт",
                      "Уровень ответственности",
                      "Этажность",
                      "Период колебаний",
                      "Наименование работы",
                      "Ссылка на объект",
                      "Путь к папке",
                    ].map((item, index) => (
                      <CTableRow key={index}>
                        <CTableDataCell>{item}</CTableDataCell>
                        <CTableDataCell><input type="text" /></CTableDataCell>
                      </CTableRow>
                    ))}
                  </CTableBody>
                </CTable>
              </div>
            </CTabPanel>

            {/* Основание выполнения работ */}
            <CTabPanel itemKey={2}>
              <p>Обоснования, на основании которого выполняется обследование:
              </p>
              <div className="fields-container">
                <div className="field-group">
                  <label>Обоснование:</label>
                  <textarea rows="3" />
                </div>
                
                <div className="fields-row">
                  <div className="field-group">
                    <label>Организация:</label>
                    <input type="text" />
                  </div>
                  <div className="field-group">
                    <label>Титул работы:</label>
                    <input type="text" />
                  </div>
                </div>

                <div className="fields-row">
                  <div className="field-group">
                    <label>Работа:</label>
                    <input type="text" />
                  </div>
                  <div className="field-group">
                    <label>Шифр:</label>
                    <input type="text" />
                  </div>
                </div>

                <div className="fields-row">
                  <div className="field-group">
                    <label>Договор №:</label>
                    <input type="text" />
                  </div>
                  <div className="field-group">
                    <label>Дата договора:</label>
                    <input type="date" />
                  </div>
                </div>

                <div className="fields-row">
                  <div className="field-group">
                    <label>Окончание по договору:</label>
                    <input type="date" />
                  </div>
                  <div className="field-group">
                    <label>Ответственный:</label>
                    <input type="text" />
                  </div>
                </div>

                <div className="field-group">
                  <label>Техническое задание:</label>
                  <input type="text" />
                </div>

                <CButton className="mt-3">План ОТР</CButton>
              </div>
            </CTabPanel>

            {/* Сведения о специалистах */}
            <CTabPanel itemKey={3}>
              <p>Обследование строительных конструкций и оформление отчетной документации проводилась следующими специалистами:</p>
                <CButton  color="black" onClick={handleAddSpecialist}>Добавить</CButton>
                <CButton  color="black" onClick={() => handleRemoveSpecialist(specialists[specialists.length - 1]?.id)}>Удалить</CButton>
                <CButton color="black">Создать список по умолчанию</CButton>

              <CTable bordered hover>
                <CTableHead>
                  <CTableRow>
                    <CTableHeaderCell>№</CTableHeaderCell>
                    <CTableHeaderCell>Исполнитель</CTableHeaderCell>
                    <CTableHeaderCell>Должность</CTableHeaderCell>
                    <CTableHeaderCell>Удостоверение</CTableHeaderCell>
                    <CTableHeaderCell>Вид работы</CTableHeaderCell>
                  </CTableRow>
                </CTableHead>
                <CTableBody>
                  {specialists.map((s, index) => (
                    <CTableRow key={s.id}>
                      <CTableDataCell>{index + 1}</CTableDataCell>
                      <CTableDataCell><input type="text" /></CTableDataCell>
                      <CTableDataCell><input type="text" /></CTableDataCell>
                      <CTableDataCell><input type="text" /></CTableDataCell>
                      <CTableDataCell><input type="text" /></CTableDataCell>
                    </CTableRow>
                  ))}
                </CTableBody>
              </CTable>
            </CTabPanel>

            {/* Средства измерения и контроля */}
            <CTabPanel itemKey={4}>
              <p>Инструментальное обследование конструкций опоры выолнялось с помощью измерительных приборов и средств контроля:</p>
                <CButton onClick={handleAddMeasurementTool}>Добавить</CButton>
                <CButton onClick={() => handleRemoveMeasurementTool(measurementTools[measurementTools.length - 1]?.id)}>Удалить</CButton>
                <CButton>↑</CButton>
                <CButton>↓</CButton>
                <CButton>Создать список по умолчанию</CButton>
                <CFormCheck 
                  label="Выводить в отчет информацию о проверке"
                  checked={showVerification}
                  onChange={(e) => setShowVerification(e.target.checked)}
                />

              <CTable bordered hover>
                <CTableHead>
                  <CTableRow>
                    <CTableHeaderCell>№</CTableHeaderCell>
                    <CTableHeaderCell>Работа</CTableHeaderCell>
                    <CTableHeaderCell>Содержание</CTableHeaderCell>
                    <CTableHeaderCell>Средство измерения</CTableHeaderCell>
                  </CTableRow>
                </CTableHead>
                <CTableBody>
                  {measurementTools.map((t, index) => (
                    <CTableRow key={t.id}>
                      <CTableDataCell>{index + 1}</CTableDataCell>
                      <CTableDataCell><input type="text" /></CTableDataCell>
                      <CTableDataCell><input type="text" /></CTableDataCell>
                      <CTableDataCell><input type="text" /></CTableDataCell>
                    </CTableRow>
                  ))}
                </CTableBody>
              </CTable>
            </CTabPanel>
          
            
             {/* Организация, проводившая обследование */}
             <CTabPanel itemKey={5}>
              <div className="fields-container">
                <div className="field-group">
                  <label>Организация:</label>
                  <input type="text" />
                </div>
                <div className="field-group">
                  <label>Время проведения обследования:</label>
                  <input type="date" />
                  <CFormCheck label="Взять дату из фотоматериалов" />
                </div>
                <div className="field-group">
                  <label>Срок очередного обследования:</label>
                  <input type="date" />
                </div>
                <div className="field-group">
                  <label>Причина обследования:</label>
                  <input type="text" />
                </div>
                <div className="field-group">
                  <label>Категория технического состояния:</label>
                  <CFormSelect>
                    <option>Выберите категорию</option>
                    <option>Категория 1</option>
                    <option>Категория 2</option>
                    <option>Категория 3</option>
                  </CFormSelect>
                  <CFormCheck label="Предварительная категория" />
                  <CFormCheck label="Не выводить категорию технического состояния" />
                </div>
                <div className="field-group">
                  <label>Условия дальней эксплуатации:</label>
                  <input type="text" />
                </div>
              </div>
            </CTabPanel>

             {/* Программа работ */}
             <CTabPanel itemKey={6}>
              <CButton>Добавить</CButton>
              <CButton>Удалить</CButton>
              <CButton>Редактировать</CButton>
              <CButton>Выше</CButton>
              <CButton>Ниже</CButton>
              <CTable bordered hover>
                <CTableHead>
                  <CTableRow>
                    <CTableHeaderCell>№</CTableHeaderCell>
                    <CTableHeaderCell>Наименование этапа обследования</CTableHeaderCell>
                    <CTableHeaderCell>Наименование работ</CTableHeaderCell>
                  </CTableRow>
                </CTableHead>
                <CTableBody></CTableBody>
              </CTable>
            </CTabPanel>

            {/* Климатические параметры */}
            <CTabPanel itemKey={7}>
              <CButton>Климатические параметры</CButton>
              <CButton>Загрузить данные</CButton>
              <CTable bordered hover>
                <CTableHead>
                  <CTableRow>
                    <CTableHeaderCell>№</CTableHeaderCell>
                    <CTableHeaderCell>Наименование характеристики</CTableHeaderCell>
                    <CTableHeaderCell>Показатель</CTableHeaderCell>
                    <CTableHeaderCell>Ссылка на нормативный документ</CTableHeaderCell>
                  </CTableRow>
                </CTableHead>
                <CTableBody>
                  {["Снеговой район", "Ветровой район", "Тип местности", "Гололедный район", "Сейсмический район", "Отрицательная расчетная температура", "Среднегодовая температура воздуха", "Климатический район"].map((item, index) => (
                    <CTableRow key={index}>
                      <CTableDataCell>{index + 1}</CTableDataCell>
                      <CTableDataCell>{item}</CTableDataCell>
                      <CTableDataCell><input type="text" /></CTableDataCell>
                      <CTableDataCell><input type="text" /></CTableDataCell>
                    </CTableRow>
                  ))}
                </CTableBody>
              </CTable>
            </CTabPanel>

            {/* Состав пояснительной записки */}
            <CTabPanel itemKey={8}>
              <CButton>Добавить</CButton>
              <CButton>Удалить</CButton>
              <CButton>Выше</CButton>
              <CButton>Ниже</CButton>
              <CButton>Создать список по умолчанию</CButton>
              <CTable bordered hover>
                <CTableHead>
                  <CTableRow>
                    <CTableHeaderCell>№ раздела</CTableHeaderCell>
                    <CTableHeaderCell>Наименование документа</CTableHeaderCell>
                  </CTableRow>
                </CTableHead>
                <CTableBody>
                  {["Содержание", "Введение", "Программа проведения обследования строительных конструкций", "Перечень технических специалистов", "Средства измерения и контроля", "Климатические параметры района установки", "Анализ проектной, исполнительной и эксплуатационной документации - Форма 1", "Конструктивные решения", "Технологическое оборудование", "Критерии оценки технического состояния конструкций", "Оценка технического состояния конструкций и анализ результатов обследования", "Рекомендации по дальнейшей эксплуатации объекта - Форма 2"].map((item, index) => (
                    <CTableRow key={index}>
                      <CTableDataCell>{index + 1}</CTableDataCell>
                      <CTableDataCell>{item}</CTableDataCell>
                    </CTableRow>
                  ))}
                </CTableBody>
              </CTable>
            </CTabPanel>
          </CTabContent>
        </CTabs>

        <div className="button-group fixed-buttons always-visible">
          <div className="left-buttons">
            <CButton>Сохранить</CButton>
            <CButton>План работ</CButton>
            <CButton>График работ</CButton>
          </div>
          <div className="right-buttons">
            <CButton>OK</CButton>
            <CButton onClick={onClose}>Отмена</CButton>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AddWindow;